import React, { FC } from 'react';
import { useNavigate } from 'react-router';

import { useGetCustomerAccountQuery } from 'src/api/@generated/backend-api';

import { i18n } from 'src/i18n';
import { NavigationService } from 'src/services/navigation-service';
import { CommonError } from 'src/components/common-error';
import { owlImageProps } from 'src/resources/images';

export const PageWrongRole: FC = () => {
  const { data: accounts } = useGetCustomerAccountQuery();
  const navigate = useNavigate();

  const accountErrorButton =
    accounts && accounts.length > 1
      ? {
          buttonText: i18n.page.error.wrongRole.goToAccount,
          onButtonClick: () => navigate(NavigationService.CHOOSE_ACCOUNT),
        }
      : {};

  return (
    <CommonError
      title={i18n.page.error.wrongRole.title}
      subtitle={[i18n.page.error.wrongRole.accountOwner, i18n.page.error.wrongRole.selectCorrectAccount]}
      hideCustomerServiceText={true}
      {...accountErrorButton}
      image={owlImageProps}
    />
  );
};
